import {
    tableA1a,
    tableA1b,
    tableA2,
    tableA4,
    tableA5
} from "./formulaAtables";

import {faeDebugger} from "../../../faeDebugger";

import {DEBUG_MODE} from "../constants/DEBUG_MODE";

//  Formula A - Dependent Students
export const FormulaA = (formData) => {

    let debugObject = [];

    //  Total Parent Income Additions (sum of lines a, b, c, d, e, and f)
    let line1 = () => {
        //  a.Parents’ AGI
        let line1a = () => {
            return parseInt(formData.step3.parentAdjustedGrossIncome);
        };

        //  b.Parents’ Deductible Payments to IRA/KEOGH/Other
        let line1b = () => {
            return 0;
        };

        //  c.Parents’ Tax-Exempt Interest Income
        let line1c = () => {
            return 0;
        };

        //  d. Parents’ Untaxed Portions of IRA Distributions
        //     (Excluding rollovers; if less than zero, enter zero)
        let line1d = () => {
            return 0;
        };

        //  e. Parents’ Untaxed Portions of Pensions
        //     (Excluding rollovers; if less than zero, enter zero)
        let line1e = () => {
            return 0;
        };

        //  f. Parents’ Foreign Income Exclusion
        //     (reported on U.S. Tax Return; if less than zero, enter the absolute value)
        let line1f = () => {
            return 0;
        };

        //  1. Total Parent Income Additions (sum of lines a, b, c, d, e, and f)
        let line1 = () => {
            let sum = line1a() + line1b() + line1c() + line1d() + line1e() + line1f() +
                parseInt(formData.step3.parentOtherIncome);

            debugObject['line 1'] = {
                'a': line1a(),
                'b': line1b(),
                'c': line1c(),
                'd': line1d(),
                'e': line1e(),
                'f': line1f(),
                'other': parseInt(formData.step3.parentOtherIncome),
                'SUM': sum
            };

            return sum;
        };

        return line1();
    };

    //  Total Parent Income Offsets (sum of lines g, h, and i)
    let line2 = () => {
        //  g.  Parents’ Taxable College Grant and Scholarship Aid (reportedas income)
        let line2g = () => {
            return 0;
        };

        //  h.  Parents’ Education Credits
        let line2h = () => {
            return 0;
        };

        //  i.  Parents’ Federal Work-study (FWS)
        let line2i = () => {
            return 0;
        }

        let sum = line2g() + line2h() + line2i();

        debugObject['line 2'] = {
            'g': line2g(),
            'h': line2h(),
            'i': line2i(),
            'SUM': sum
        };

        return sum;
    };

    //  Total Parent Income (line 1 minus line 2)
    //      • Total Parent Income Additions – Total Parent Income Offsets
    //      • May be a negative number
    let line3 = () => {
        let value = line1() - line2();
        debugObject['line 3'] = value;
        return value;
    };

    //  Total Parent Allowances Against Income (sum lines 4, 5a, 5b, 6,and 7)
    let line8 = () => {
        //  Parents’ U.S. Income Tax Paid (or Foreign Equivalent)
        let line4 = () => {
            debugObject['line 4'] = parseInt(formData.step3.parentTaxesPaid);
            return parseInt(formData.step3.parentTaxesPaid);
        };

        //  Payroll Tax Allowance (Table A1)
        let line5 = () => {
            //  Medicare’s Hospital Insurance (HI) Program Tax Rate (TableA1: Step 1)
            let line5a = () => {
                return tableA1a(formData, true);
            }

            //  Old-age, survivors, & disability insurance (OASDI) Tax Rate(Table A1: Step 2)
            let line5b = () => {
                return tableA1b(formData, true);
            }

            let value = {
                'a': line5a(),
                'b': line5b()
            };

            debugObject['line 5'] = value;
            return value;
        };

        //  Income Protection Allowance (Table A2)
        //      • Use the calculated Family Size to determine the IPA
        let line6 = () => {
            let value = tableA2(formData.step3.familySize);
            debugObject['line 6'] = value;
            return value;
        };

        //  Employment Expense Allowance (EEA)
        //      • The lesser of:
        //          ▪ 35% of parents’ combined income, OR
        //          ▪ $4,730
        let line7 = () => {
            let percent = 0.35;
            let check1 = Math.round(line3() * percent);
            let check2 = 4730;

            let value = Math.min(check1, check2);
            debugObject['line 7'] = value;
            return value;
        };

        //  Total Parent Allowances Against Income (sum lines 4, 5a, 5b, 6,and 7)
        let line8 = () => {
            let value = line4() + line5()['a'] + line5()['b'] + line6() + line7();
            debugObject['line 8'] = value;
            return value;
        };

        return line8();
    };

    //  Parent Available Income (line 3 minus line 8)
    //      • May be a negative number
    let line9 = () => {
        let value = line3() - line8();
        debugObject['line 9'] = value;
        return value;
    }

    let line17 = () => {
        //  Annual child support received for the last complete calendar year
        let line10 = () => {
            let value = 0;
            debugObject['line 10'] = value;
            return value;
        };

        //  Cash, savings, and checking accounts
        let line11 = () => {
            let value = parseInt(formData.step3.parentAssets);
            debugObject['line 11'] = value;
            return value;
        };

        //  Net worth of investments
        //      • Includes: time deposits, money market funds, real estate (excluding primary residence),
        //        vacation homes, income producing property, trusts, stocks, bonds, derivatives, securities,
        //        mutual funds,tax shelters, and qualified education benefits
        //      • If negative, enter zero
        let line12 = () => {
            let value = 0;
            debugObject['line 12'] = value;
            return value;
        };

        //  Adjusted net worth of business and/or farm (Table A3)
        //      • Net worth of business and/or farm multiplied by the applicable adjustment in Table A3
        let line13 = () => {
            let value = 0;
            debugObject['line 13'] = value;
            return value;
        };

        //  Net worth (sum of lines 10, 11, 12, and 13)
        let line14 = () => {
            let value = line10() + line11() + line12() + line13();
            debugObject['line 14'] = value;
            return value;
        };

        //  Asset Protection Allowance (APA) (Table A4)
        let line15 = () => {
            let value = tableA4(45);
            debugObject['line 15'] = value;
            return value;
        };

        //  Asset Conversion Rate (12%)
        let line16 = () => {
            let value = 0.12;
            debugObject['line 16'] = value;
            return value;
        };

        //  Parent Contribution from Assets (PCA)
        //      • (Line 14 minus line 15) times line 16
        //      • If negative, enter zero
        let line17 = () => {
            let value = Math.round((line14() - line15()) * line16());
            value = (value < 0) ? 0 : value;

            debugObject['line 17'] = value;
            return value;
        };

        return line17();
    };

    //  Parent Adjusted Available Income (line 9 plus line 17)
    //      • May be a negative number
    let line18 = () => {
        let value = line9() + line17();
        debugObject['line 18'] = value;
        return value;
    };

    //  Parents’ Contribution (Table A5)
    //      • Adjust PAAI (line 18) using Table A5
    let line19 = () => {
        let value = tableA5(line18());
        debugObject['line 19'] = value;
        return value;
    };

    //  Total Student Income Additions (sum of lines a, b, c, d, e, and f)
    let line20 = () => {

        //  Student AGI
        let line20a = () => {
            return parseInt(formData.step3.studentAdjustedGrossIncome);
        };

        //  Student Deductible Payments to IRA/KEOGH/Other
        let line20b = () => {
            return 0;
        };

        //  Student Exempt Interest Income
        let line20c = () => {
            return 0;
        };

        //  Student Untaxed Portions of IRA Distributions
        //  (Excluding rollovers; if less than zero, enter zero)
        let line20d = () => {
            return 0;
        };

        //  Student Untaxed Portions of Pensions
        //  (Excluding rollovers; if less than zero, enter zero)
        let line20e = () => {
            return 0;
        }

        //  Student Foreign Income Exclusion
        //  (reported on U.S. Tax Return; if less than zero, enter the absolute value)
        let line20f = () => {
            return 0;
        };

        //  Total Student Income Additions (sum of lines a, b, c, d, e, and f)
        let line20 = () => {
            let value = line20a() + line20b() + line20c() + line20d() + line20e() + line20f() +
                parseInt(formData.step3.studentOtherIncome);

            debugObject['line 20'] = {
                'a': line20a(),
                'b': line20b(),
                'c': line20c(),
                'd': line20d(),
                'e': line20e(),
                'f': line20f(),
                'other': parseInt(formData.step3.studentOtherIncome),
                'SUM': value
            };

            return value;
        };

        return line20();
    };

    //  Total Student Income Offsets (sum of lines g, h, and i)
    let line21 = () => {
        //  Student College Grant and Scholarship Aid (reported as income)
        let line21g = () => {
            return 0;
        };

        //  Student Education Credits
        let line21h = () =>{
            return 0;
        };

        //  Student Federal Work-study (FWS)
        let line21i = () => {
            return 0;
        };

        //  Total Student Income Offsets (sum of lines g, h, and i)
        let line21 = () => {
            let value = line21g() + line21h() + line21i();
            debugObject['line 21'] = {
                'g': line21g(),
                'h': line21h(),
                'i': line21i(),
                'SUM': value
            };
            return value;
        };

        return line21();
    };

    //  Total Student Income (line 20 minus line 21)
    //      • Total Student Income Additions – Total Student Income Offsets
    //      • May be a negative number
    let line22 = () => {
        let value = line20() - line21();
        debugObject['line 22'] = value;
        return value;
    };

    //  Student U.S. Income Tax Paid (or Foreign Equivalent)
    let line23 = () => {
        let value = parseInt(formData.step3.studentTaxesPaid);
        debugObject['line 23'] = value;
        return value;
    };

    //  Total Student Allowances Against Income (sum lines 23, 24a, 24b,25, and 26)
    let line27 = () => {
        //  Payroll Tax Allowance (Table A1)
        let line24 = () => {
            //  Medicare’s Hospital Insurance (HI) Program Tax Rate (TableA1: Step 1)
            let line24a = () => {
                return tableA1a(formData, false);
            };

            //  Old-age, survivors, & disability insurance (OASDI) Tax Rate(Table A1: Step 2)
            let line24b = () => {
                return tableA1b(formData, false);
            }

            let line24 = () => {
                return {
                    'a': line24a(),
                    'b': line24b()
                };
            }

            let value = line24();
            debugObject['line 24'] = value;
            return value;
        };

        //  Income Protection Allowance
        let line25 = () => {
            let value = 11130;
            debugObject['line 25'] = value;
            return value;
        };

        //  Allowance for parents’ negative adjusted available income
        //      a. If line 18 is negative, enter line 18 as a positive number
        //      b. If line 18 is zero or positive, enter zero
        let line26 = () => {
            let value = line18();
            value = (value < 0) ? -value : 0;
            debugObject['line 26'] = value;
            return value;
        };

        //  Total Student Allowances Against Income (sum lines 23, 24a, 24b,25, and 26)
        let line27 = () => {
            let value = line23() + line24()['a'] + line24()['b'] + line25() + line26();
            debugObject['line 27'] = value;
            return value;
        }

        return line27();
    };

    //  Student Available Income (line 22 minus line 27)
    //  May be a negative number
    let line28 = () => {
        let value = line22() - line27();
        debugObject['line 28'] = value;
        return value;
    };

    //  Assessment of Student Available Income
    let line29 = () => {
        let value = 0.50;
        debugObject['line 29'] = value;
        return value;
    };

    //  Student’s Contribution from Income (line 28 times line 29)
    //      • If negative and < -1,500, adjust to -1,500 (e.g., if -2,000 set to -1,500)
    //      • If negative and >= -1,500, do not adjust (e.g., if -1,000 leave as -1,000)
    let line30 = () => {
        let value = line28() * line29();
        let constant = -1500;
        value = (value < constant)
            ? constant
            : value;

        value = Math.round(value);
        debugObject['line 30'] = value;
        return value;
    };

    //  Student Contribution from Assets (SCA)
    //      • Line 34 times line 35
    //      • If negative, enter zero
    let line36 = () => {
        //  Cash, savings, and checking accounts
        let line31 = () => {
            let value = parseInt(formData.step3.studentAssets);
            debugObject['line 31'] = value;
            return value;
        };

        //  Net worth of investments
        //      • Includes: time deposits, money market funds, real estate (excluding primary residence),
        //        vacation homes, income producing property, trusts, stocks, bonds, derivatives, securities,
        //        mutual funds, tax shelters, and qualified education benefits
        //      • If negative, enter zero
        let line32 = () => {
            let value = 0;
            debugObject['line 32'] = value;
            return value;
        };

        //  Adjusted net worth of business and/or farm (Table A3)
        //      • Net worth of business and/or farm multiplied by the applicable adjustment in Table A3
        let line33 = () => {
            let value = 0;
            debugObject['line 33'] = value;
            return value;
        };

        //  Net worth (sum of lines 31, 32, and 33)
        let line34 = () => {
            let value = line31() + line32() + line33();
            debugObject['line 34'] = value;
            return value;
        };

        //  Asset Conversion Rate (20%)
        let line35 = () => {
            let value = 0.20;
            debugObject['line 35'] = value;
            return value;
        };

        //  Student Contribution from Assets (SCA)
        //      • Line 34 times line 35
        //      • If negative, enter zero
        let line36 = () => {
            let value = Math.round(line34() * line35());
            if (value < 0) {
                value = 0;
            }
            debugObject['line 36'] = value;
            return value;
        };

        return line36();
    };

    //  Student Aid Index (sum of lines 19, 30, and 36)
    //      • If negative and < -1,500, adjust to -1,500 (e.g., if -2,000 set to -1,500)
    //      • If negative and >= -1,500, do not adjust (e.g., if -1,000 leave as -1,000)
    let line37 = () => {
        let value = line19() + line30() + line36();
        value = (value < -1500) ? -1500: value;
        debugObject['line 37'] = value;
        return value;
    };

    let value = line37();

    if(DEBUG_MODE === true) {
        //  This one's a little cleaner, and it handles console.group() automatically, preventing dangling output.

        let debugBlock = new faeDebugger('Formula A - Dependent Students');
        let blockInputs = new faeDebugger('Inputs');
        let blockParentContributionFromIncome = new faeDebugger('Parent Contribution from Income');
        let blockParentIncomeAdditions = new faeDebugger('Parent Income Additions');
        let blockParentIncomeOffsets = new faeDebugger('Parent Income Offsets');
        let blockParentIncomeAllowances = new faeDebugger('Allowances Against Parents Income');
        let blockParentAvailableIncome = new faeDebugger('Parents Available Income (PAI)');
        let blockParentContributionAssets = new faeDebugger('Parent Contribution from Assets');
        let blockParentTotalContribution = new faeDebugger('Total Parent Contribution');
        let blockParentAdjustedAvailableIncome = new faeDebugger('Parent Adjusted Available Income (PAAI)');
        let blockParentContribution = new faeDebugger('Parents Contribution');
        let blockStudentContributionFromIncome = new faeDebugger('Student Contribution From Income');
        let blockStudentIncomeAdditions = new faeDebugger('Student Income Additions');
        let blockStudentIncomeOffsets = new faeDebugger('Student Income Offsets');
        let blockStudentAllowancesAgainstIncome = new faeDebugger('Allowances Against Student Income');
        let blockStudentsContributionFromIncome = new faeDebugger('Student\'s Contribution from Income');
        let blockStudentContributionFromAssets = new faeDebugger('Student Contribution from Assets');
        let blockStudentAidIndex = new faeDebugger('Student Aid Index (SAI)');

        debugBlock.addBlock('00', blockInputs);
        blockInputs.addLine('Parent Adjusted Gross Income', `calculated: ${parseInt(formData.step3.parentAdjustedGrossIncome)} - text input: "${formData.step3.parentAdjustedGrossIncome}"`);
        blockInputs.addLine('Parent Other Income', `calculated: ${parseInt(formData.step3.parentOtherIncome)} - text input: "${formData.step3.parentOtherIncome}"`);
        blockInputs.addLine('Parent Taxes Paid', `calculated: ${parseInt(formData.step3.parentTaxesPaid)} - text input: "${formData.step3.parentTaxesPaid}"`);
        blockInputs.addLine('Parent Assets', `calculated: ${parseInt(formData.step3.parentAssets)} - text input: "${formData.step3.parentAssets}"`);
        blockInputs.addLine('Family Size', `calculated: ${parseInt(formData.step3.familySize)} - text input: "${formData.step3.familySize}"`);
        blockInputs.addLine('Student Adjusted Gross Income', `calculated: ${parseInt(formData.step3.studentAdjustedGrossIncome)} - text input: "${formData.step3.studentAdjustedGrossIncome}"`);
        blockInputs.addLine('Student Other Income', `calculated: ${parseInt(formData.step3.studentOtherIncome)} - text input: "${formData.step3.studentOtherIncome}"`);
        blockInputs.addLine('Student Taxes Paid', `calculated: ${parseInt(formData.step3.studentTaxesPaid)} - text input: "${formData.step3.studentTaxesPaid}"`);
        blockInputs.addLine('Student Assets', `calculated: ${parseInt(formData.step3.studentAssets)} - text input: "${formData.step3.studentAssets}"`);

        debugBlock.addBlock('01', blockParentContributionFromIncome);
        blockParentContributionFromIncome.addBlock('00',blockParentIncomeAdditions);
        blockParentIncomeAdditions.addLine('a', debugObject['line 1']['a']);
        blockParentIncomeAdditions.addLine('b', debugObject['line 1']['b']);
        blockParentIncomeAdditions.addLine('c', debugObject['line 1']['c']);
        blockParentIncomeAdditions.addLine('d', debugObject['line 1']['d']);
        blockParentIncomeAdditions.addLine('e', debugObject['line 1']['e']);
        blockParentIncomeAdditions.addLine('f', debugObject['line 1']['f']);
        blockParentIncomeAdditions.addLine('other income', debugObject['line 1']['other']);
        blockParentIncomeAdditions.addLine('1', debugObject['line 1']['SUM']);

        blockParentContributionFromIncome.addBlock('01',blockParentIncomeOffsets);
        blockParentIncomeOffsets.addLine('g', debugObject['line 2']['g']);
        blockParentIncomeOffsets.addLine('h', debugObject['line 2']['h']);
        blockParentIncomeOffsets.addLine('i', debugObject['line 2']['i']);
        blockParentIncomeOffsets.addLine('2', debugObject['line 2']['2']);
        blockParentIncomeOffsets.addLine('3', debugObject['line 2']['3']);

        blockParentContributionFromIncome.addBlock('02',blockParentIncomeAllowances);
        blockParentIncomeAllowances.addLine('4', debugObject['line 4']);
        blockParentIncomeAllowances.addLine('5a', debugObject['line 5']['a']);
        blockParentIncomeAllowances.addLine('5b', debugObject['line 5']['b']);
        blockParentIncomeAllowances.addLine('6', debugObject['line 6']);
        blockParentIncomeAllowances.addLine('7', debugObject['line 7']);
        blockParentIncomeAllowances.addLine('8', debugObject['line 8']);

        blockParentContributionFromIncome.addBlock('03',blockParentAvailableIncome);
        blockParentAvailableIncome.addLine(' ', debugObject['line 3']);
        blockParentAvailableIncome.addLine(' ', debugObject['line 8']);
        blockParentAvailableIncome.addLine('9', debugObject['line 9']);

        debugBlock.addBlock('02', blockParentContributionAssets);
        blockParentContributionAssets.addLine('10', debugObject['line 10']);
        blockParentContributionAssets.addLine('11', debugObject['line 11']);
        blockParentContributionAssets.addLine('12', debugObject['line 12']);
        blockParentContributionAssets.addLine('13', debugObject['line 13']);
        blockParentContributionAssets.addLine('14', debugObject['line 14']);
        blockParentContributionAssets.addLine('15', debugObject['line 15']);
        blockParentContributionAssets.addLine('16', debugObject['line 16']);
        blockParentContributionAssets.addLine('17', debugObject['line 17']);

        debugBlock.addBlock('03', blockParentTotalContribution);
        blockParentTotalContribution.addBlock('00', blockParentAdjustedAvailableIncome);
        blockParentAdjustedAvailableIncome.addLine(' ', debugObject['line 9']);
        blockParentAdjustedAvailableIncome.addLine(' ', debugObject['line 17']);
        blockParentAdjustedAvailableIncome.addLine('18', debugObject['line 18']);

        blockParentTotalContribution.addBlock('01', blockParentContribution);
        blockParentContribution.addLine('19', debugObject['line 19']);

        debugBlock.addBlock('04', blockStudentContributionFromIncome);
        blockStudentContributionFromIncome.addBlock('00', blockStudentIncomeAdditions);
        blockStudentIncomeAdditions.addLine('a', debugObject['line 20']['a']);
        blockStudentIncomeAdditions.addLine('b', debugObject['line 20']['b']);
        blockStudentIncomeAdditions.addLine('c', debugObject['line 20']['c']);
        blockStudentIncomeAdditions.addLine('d', debugObject['line 20']['d']);
        blockStudentIncomeAdditions.addLine('e', debugObject['line 20']['e']);
        blockStudentIncomeAdditions.addLine('f', debugObject['line 20']['f']);
        blockStudentIncomeAdditions.addLine('other', debugObject['line 20']['other']);
        blockStudentIncomeAdditions.addLine('20', debugObject['line 20']['SUM']);

        blockStudentContributionFromIncome.addBlock('01', blockStudentIncomeOffsets);
        blockStudentIncomeOffsets.addLine('g',debugObject['line 21']['g']);
        blockStudentIncomeOffsets.addLine('h',debugObject['line 21']['h']);
        blockStudentIncomeOffsets.addLine('i',debugObject['line 21']['i']);
        blockStudentIncomeOffsets.addLine('21',debugObject['line 21']['SUM']);
        blockStudentIncomeOffsets.addLine('22',debugObject['line 21']['line 22']);

        blockStudentContributionFromIncome.addBlock('02', blockStudentAllowancesAgainstIncome);
        blockStudentAllowancesAgainstIncome.addLine('23', debugObject['line 23']);
        blockStudentAllowancesAgainstIncome.addLine('24a', debugObject['line 24']['a']);
        blockStudentAllowancesAgainstIncome.addLine('24b', debugObject['line 24']['b']);
        blockStudentAllowancesAgainstIncome.addLine('25', debugObject['line 25']);
        blockStudentAllowancesAgainstIncome.addLine('26', debugObject['line 26']);
        blockStudentAllowancesAgainstIncome.addLine('27', debugObject['line 27']);

        blockStudentContributionFromIncome.addBlock('03', blockStudentsContributionFromIncome);
        blockStudentsContributionFromIncome.addLine(' ', debugObject['line 22']);
        blockStudentsContributionFromIncome.addLine(' ', debugObject['line 27']);
        blockStudentsContributionFromIncome.addLine('28', debugObject['line 28']);
        blockStudentsContributionFromIncome.addLine('29', debugObject['line 29']);
        blockStudentsContributionFromIncome.addLine('30', debugObject['line 30']);

        debugBlock.addBlock('05', blockStudentContributionFromAssets);
        blockStudentContributionFromAssets.addLine('31', debugObject['line 31']);
        blockStudentContributionFromAssets.addLine('32', debugObject['line 32']);
        blockStudentContributionFromAssets.addLine('33', debugObject['line 33']);
        blockStudentContributionFromAssets.addLine('34', debugObject['line 34']);
        blockStudentContributionFromAssets.addLine('35', debugObject['line 35']);
        blockStudentContributionFromAssets.addLine('36', debugObject['line 36']);

        debugBlock.addBlock('06', blockStudentAidIndex);
        blockStudentAidIndex.addLine(' ', debugObject['line 19']);
        blockStudentAidIndex.addLine(' ', debugObject['line 30']);
        blockStudentAidIndex.addLine(' ', debugObject['line 36']);
        blockStudentAidIndex.addLine('37', debugObject['line 37']);

        debugBlock.toGroup();
    }

    return value;
};


